import React from "react";
import ContactImport from "../../components/ContactImport";
import MainContainer from "../../components/MainContainer";
import { PageHeader } from "../../components/ui";

// O próprio ContactImport desenha os passos, os cartões e a tabela da planilha.
const ContactImportPage = () => {
  return (
    <MainContainer maxWidth>
      <PageHeader
        title="Importar contatos de arquivo" // TODO i18n
        subtitle="Envie uma planilha e mapeie as colunas para criar contatos em lote." // TODO i18n
      />
      <ContactImport />
    </MainContainer>
  );
};

export default ContactImportPage;
